import { lazy, Suspense } from "react";
import ProtectedRoute from "../components/ProtectedRoute";

export const createLazyPage = (Path, fileName) =>
	lazy(() => import(`../pages/${Path}/${fileName}.jsx`));

export const createCrudPages = (Path, Sufiks) => ({
	Index: createLazyPage(Path, `Index${Sufiks}`),
	Show: createLazyPage(Path, `Show${Sufiks}`),
	Create: createLazyPage(Path, `Create${Sufiks}`),
	Edit: createLazyPage(Path, `Edit${Sufiks}`),
});

export const wrapElement = (Component, isProtected = true) => {
	const Wrapper = () => (
		<Suspense fallback={<div className="text-center p-4">Loading...</div>}>
			<Component />
		</Suspense>
	);

	if (!isProtected) {
		return <Wrapper />;
	}

	return (
		<ProtectedRoute>
			<Wrapper />
		</ProtectedRoute>
	);
};

export const generateApiRoutes = (basePath, components, options = {}) => {
	const isProtected = options.isProtected ?? true;
	const enabled = options.enabled ?? true;

	const [IndexComponent, ShowComponent, CreateComponent, EditComponent] =
		components;

	return [
		{
			path: `/${basePath}`,
			element: wrapElement(IndexComponent, isProtected),
			enabled,
		},
		{
			path: `/${basePath}/:id`,
			element: wrapElement(ShowComponent, isProtected),
			enabled,
		},
		{
			path: `/${basePath}/create`,
			element: wrapElement(CreateComponent, isProtected),
			enabled,
		},
		{
			path: `/${basePath}/:id/edit`,
			element: wrapElement(EditComponent, isProtected),
			enabled,
		},
	];
};

export const generateNestedRoutes = (
	basePath,
	layoutComponent,
	childRoutes,
) => {
	return {
		path: basePath,
		element: layoutComponent,
		children: childRoutes.map((route) => ({
			path: route.path,
			element: route.element,
			index: route.index || false,
		})),
	};
};

export const flattenNestedRoutes = (nestedRoute) => {
	const flattened = [];

	flattened.push({
		path: nestedRoute.path,
		element: nestedRoute.element,
		enabled: true,
	});

	if (nestedRoute.children) {
		nestedRoute.children.forEach((child) => {
			const fullPath = child.index
				? nestedRoute.path
				: `${nestedRoute.path}/${child.path}`;
			flattened.push({
				path: fullPath,
				element: child.element,
				enabled: true,
			});
		});
	}

	return flattened;
};
